/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import { StepMetadata_CustomerFragmentDoc } from './StepMetadata.graphql';
import { CustomerSubscriptionData_CustomerFragmentDoc } from '../../../customers/__generated__/CustomersGridItem.graphql';
export type Wizard_CustomerFragment = { __typename: 'Customer', id: string, displayCount: number, waveSubscriptionUsage?: number | null, waveSubscription?: { __typename: 'WaveSubscription', id: string, usage: { __typename: 'SubscriptionUsage', current: number, max?: number | null } } | null, waveSubscriptions?: Array<{ __typename: 'WaveSubscription', id: string, validUntil: any, status: Types.WaveSubscriptionStatus, usage: { __typename: 'SubscriptionUsage', current: number, max?: number | null } }> | null, groups: Array<{ __typename: 'Group', id: string, name: string }> };

export const Wizard_CustomerFragmentDoc = gql`
    fragment Wizard_customer on Customer {
  id
  ...StepMetadata_customer
  waveSubscription {
    usage {
      current
      max
    }
  }
  ...CustomerSubscriptionData_customer
  waveSubscriptions {
    id
    validUntil
    usage {
      current
      max
    }
    status
  }
}
    ${StepMetadata_CustomerFragmentDoc}
${CustomerSubscriptionData_CustomerFragmentDoc}`;